enum BorderWeights {
  regular = 2,
  thin = 1
}
export default BorderWeights;

export type BorderWeightNames = keyof typeof BorderWeights;
